module.exports = "<div>\n    <div class= \"emptyControl\"></div>\n</div>"